import { render, staticRenderFns } from "./QuestionsComponent.vue?vue&type=template&id=6f21a554&scoped=true&"
import script from "./QuestionsComponent.vue?vue&type=script&lang=js&"
export * from "./QuestionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsComponent.vue?vue&type=style&index=0&id=6f21a554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f21a554",
  null
  
)

export default component.exports